(function(Drupal, once) {
  Drupal.behaviors.repairsDurationPriceChart = {
    attach(context) {

      const canvas = once(
        'days-chart',
        '#days-chart',
        context,
      )[0];

      if (!canvas) {
        return;
      }

      let labels = [];
      let values = [];

      try {
        labels = JSON.parse(canvas.dataset.labels || '[]');
        values = JSON.parse(canvas.dataset.values || '[]');
      }
      catch (e) {
        console.error('Invalid chart data', e);
        return;
      }

      const ctx = canvas.getContext('2d');

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels.map(l => l + ' дни'),
          datasets: [
            {
              label: 'Обща сума (€)',
              data: values,
              backgroundColor: '#17c1e8',
              borderRadius: 4,
            }],
        },
        options: {
          indexAxis: 'y',
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                stepSize: 1000,
              },
            },
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    },
  };
})(Drupal, once);
